export const setErrorsFromApiV2Error = ({ error, setErrors }) => {
  if (error.status !== 422 || !error.response?.data?.errors) return;

  const formErrors = {};
  error.response.data.errors.forEach((errorItem) => {
    if (!errorItem.source?.pointer || !errorItem.source.pointer.startsWith('/data/attributes/'))
      return;

    // Remove '/data/attributes/' prefix to get the field name
    const fieldName = errorItem.source.pointer.replace('/data/attributes/', '');
    formErrors[fieldName] = errorItem.detail;
  });
  setErrors(formErrors);
};
